import {escapeSpecialChars} from "./escapeSpecialChars";

export function escapeSearchChars (text: string) {
    let newValue = text.replace(/\\\\/g, '\\');
    newValue = newValue.replace("'", "'");
    newValue = newValue.replace('\\', '\\\\');
    newValue = newValue.replace("'", "'");
    newValue = escapeSpecialChars(newValue);
    return newValue;
}